import { Link } from 'react-router-dom';

export default function WhatIsSection() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-12">
            <span className="inline-block px-3 py-1 bg-accent-100 text-accent-700 text-xs font-medium rounded-full mb-3">
              Getting Started
            </span>
            <h2 className="font-heading text-2xl md:text-4xl font-semibold text-foreground-900 mb-4">
              What Is a Basetao Spreadsheet?
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
            <div>
              <p className="text-foreground-700 leading-relaxed mb-4">
                A <strong>Basetao Spreadsheet</strong> is a powerful organization method that helps shoppers manage products, orders, shipping costs, warehouse information, and purchasing decisions — all in one structured digital document.
              </p>
              <p className="text-foreground-700 leading-relaxed mb-4">
                Instead of manually tracking multiple purchases across scattered notes, browser bookmarks, and email receipts, users can deploy structured spreadsheet systems built in <strong>Google Sheets</strong> or <strong>Microsoft Excel</strong> to improve accuracy, save money, and simplify the entire international shopping workflow.
              </p>
              <p className="text-foreground-700 leading-relaxed mb-6">
                Whether you are a casual buyer picking up a few items or a reseller managing large hauls, a well-designed Basetao spreadsheet gives you complete visibility — from product selection to final delivery.
              </p>
              <Link
                to="/basetao-spreadsheet-guide"
                className="inline-flex items-center gap-2 text-sm font-medium text-accent-600 hover:text-accent-700 transition-colors cursor-pointer"
              >
                Read the complete guide <i className="ri-arrow-right-line"></i>
              </Link>
            </div>

            <div className="bg-background-100 rounded-lg border border-background-200/60 overflow-hidden">
              <div className="p-5">
                <table className="w-full text-sm">
                  <thead>
                    <tr className="border-b border-background-200/60">
                      <th className="text-left py-3 pr-3 text-foreground-500 font-medium">Without Spreadsheet</th>
                      <th className="text-left py-3 pl-3 text-accent-700 font-medium">With Basetao Spreadsheet</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr className="border-b border-background-200/40">
                      <td className="py-3 pr-3 text-foreground-600">Lost product information</td>
                      <td className="py-3 pl-3 text-foreground-900 font-medium">Organized product database</td>
                    </tr>
                    <tr className="border-b border-background-200/40">
                      <td className="py-3 pr-3 text-foreground-600">Manual calculations</td>
                      <td className="py-3 pl-3 text-foreground-900 font-medium">Automated cost tracking</td>
                    </tr>
                    <tr className="border-b border-background-200/40">
                      <td className="py-3 pr-3 text-foreground-600">Difficult order management</td>
                      <td className="py-3 pl-3 text-foreground-900 font-medium">Clear visual workflow</td>
                    </tr>
                    <tr>
                      <td className="py-3 pr-3 text-foreground-600">Shipping confusion</td>
                      <td className="py-3 pl-3 text-foreground-900 font-medium">Transparent shipping planning</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}